// Remove direct import, use lazy loading instead
// import * as pdfjsLib from 'pdfjs-dist';
import { loadPDFJS } from './pdfLazyLoader';
import { logger } from '@/lib/logger';

// Configure PDF.js worker for version 5.x
export async function configurePDFWorker() {
  // Load PDF.js if not already loaded
  const pdfjsLib = await loadPDFJS();

  // Always use the local worker file to avoid CSP issues with external CDNs
  if (typeof window !== 'undefined' && !pdfjsLib.GlobalWorkerOptions.workerSrc) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
    logger.debug(`PDF.js worker configured with local worker`);
  }

  return pdfjsLib;
}

// Note: This function is now async and needs to be called explicitly when PDF.js is needed
